import React from 'react';
import { TextField } from '@mui/material';

export default function ServiceModelField({
  value,
  onChange,
  disabled = false,
  label = 'Model',
}) {
  return (
    <TextField
      label={label}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
    />
  );
}
